<template>
  <div class="page-box">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0px 2px 3px 0px rgba(218, 218, 218, 0.25);
        padding: 7px 16px;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        background: #fff;
        box-sizing: border-box;
      "
    >
      <img
        style="width: 132px; height: 35px"
        src="@/assets/kfimage/backHomeLogo.png"
        alt=""
      />
      <div
        style="padding: 0px 0 0 16px; display: flex; align-items: center"
        @click="handleClickForHome"
      >
        <img
          style="width: 40px; height: 28px"
          src="@/assets/kfimage/backHomeIcon.png"
          alt=""
        />
      </div>
    </div>
    <div class="view-box audio-view-box" v-if="versionUrl"></div>
    <div :class="versionUrl?'margintop':''" @click.stop="controlsShowFun" class="video-box" style="margin-top:50px">
      <!-- <video
        v-if="begin && countDownSwitch == 0 && !endimg"
        x5-video-player-type="h5"
        webkit-playsinline
        :playsinline="playsinline"
        :src="playUrl"
        :type="playerType"
        ref="video"
        class="video"
        autoplay
        :controls='controlsFlag'
      ></video> -->
      <div class="video" v-if="begin && countDownSwitch == 0 && !endimg">
        <VueAliplayerV2
              x5-video-player-type="h5"
              webkit-playsinline
              :playsinline="playsinline"
              :options="option"
              ref="video"
              style="height: 100%"
              :sourceUrl="playUrl">
        </VueAliplayerV2>
      </div>
      <div
        class="zhanwei"
        v-if="!begin && countDownSwitch == 0 && !endimg"
      ></div>
      <div
        class="playbtn"
        v-if="begin && countDownSwitch == 0 && !endimg && clicked"
      >
        <i class="begin-play" @click="videoPlay"></i>
      </div>
      <div class="noplay" v-if="noplay"></div>
      <!-- <transition name="van-fade">
        <div
          class="controls-box"
          v-show="controlsShow && !videoControls.openTD"
          @click.stop="controlsHiddenFun"
        >
          <ul class="controls-box-title">
            <li v-show="page.activityAuthor">{{ activityAuthor }}</li>
          </ul>
          <ul class="controls-box-controls">
            <li @click.stop="videoControls.play ? videoPause() : videoPlay()">
              <van-icon name="pause" v-show="videoControls.play" />
              <van-icon name="play" v-show="!videoControls.play" />
            </li>
            <li @click.stop="openTDWind" v-if="page.multiCamera == 0">
              <img class="zhankai" src="@/assets/img/shangll.png" alt="" />
            </li>
            <li @click.stop="videoFullScreen">
              <van-icon class="enlarge" name="enlarge" />
            </li>
          </ul>
        </div>
      </transition> -->
    </div>
    <div class="ios-box" v-if="IOS && iosfull">
      <video
        x5-video-player-type="h5"
        webkit-playsinline
        playsinline
        @click.stop="iosControlsShowFun"
        :src="playUrl"
        :type="playerType"
        ref="iosvideo"
        class="iosvideo"
      ></video>
      <transition name="van-fade">
        <div
          class="controls-box-ios"
          v-show="iosControlsShow"
          @click.stop="controlsHiddenFun"
        >
          <ul class="controls-box-title">
          </ul>
          <ul class="controls-box-controls">
            <li
              @click.stop="
                iosVideoControls.play ? iosVideoPause() : iosVideoPlay()
              "
            >
              <van-icon name="pause" v-show="iosVideoControls.play" />
              <van-icon name="play" v-show="!iosVideoControls.play" />
            </li>
            <li @click.stop="iosVideoFullScreen">
              <i class="iconfont icon-xiaoping"></i>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <div class="road-info" v-if="tvType=='4'">
      <img :src="tvInfo.trafficLowPath" alt="" class="left-img">
      <div class="right-box">
        <p class="title">{{tvInfo.trafficTitle}}</p>
        <div style="display:flex;justify-content: space-between;">
          <div>
            <p class="address">
          <i class="el-icon-location-outline"></i>
          {{tvInfo.location | ellipsis}}
        </p>
          </div>
          <div class="address" >
            {{format(new Date(tvInfo.CreateTime), "MM-dd HH:mm")}}
          </div>
        </div>
      </div>
    </div>
    <van-tabs
      v-model="activeName"
      v-if="editableTabs && editableTabs.length > 0"
      color="#5F93FF"
      border
      @change='tabsClick'
      >
      <van-tab
        :title="val.menuName"
        v-for="(val, ind) in editableTabs || []"
        :key="ind"
        :name="val.menuType" animated>
        <div class="tabs-box" :class="tvType=='4'?'road-box':''">
          <!-- 简介 -->
          <div class="tv-info tv-introduce"
              v-if="activeName == 1"
              v-html="val.menuContent"></div>
          <!-- 评论 -->
          <comment
            ref="childMethod"
            :userinfo="wxuserInfo"
            :tvId="$route.query.id"
            v-if="activeName == 6"
          ></comment>
          <!-- 节目单 -->
          <div v-if="activeName == 7">
            <van-tabs  v-model="active"  >
              <van-tab v-for="(item, index) in dayList" :key="index">
                <template #title>
                  <div @click="tabclick(item)">
                    <span>{{ item.day }}</span>
                    <p>{{ item.time.slice(5) }}</p>
                  </div>
                </template>
                <div class="program-list-box">
                  <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    ref="list">
                    <p  v-for="(val, ind) in programList" :key="ind">
                      <ul class="list-gift-list-item" :class="ind == valIndex?'clicked-item':''">
                        <li>
                          <span class="play-time">{{format(new Date(val.playTime),'HH:mm')}}-{{format(new Date(val.playTime+val.programTimeLength*1000),'HH:mm')}}</span>
                          <span class="play-name">{{ val.programName }}</span>
                        </li>
                        <li>
                        <van-button v-if="val.playbackFlag == 1 &&val.playTime + val.programTimeLength * 1000 < Date.now()&& !val.clicked" @click="replay(val,ind)">回看</van-button>
                        <van-button   v-if="val.clicked"   plain type="info">回看中</van-button>
                          <van-button v-if="playing(val.playTime,val.programTimeLength)" type="info" @click="showLive(val,ind)">
                          </van-button>
                        </li>
                      </ul>
                    </p>
                  </van-list>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </van-tab>
    </van-tabs> 
  </div>
</template>

<script>
import axios from "@/utils/NewLive";
import {
  mapState,
  mapMutations
} from "vuex";
import * as sctipts from "@/service/share";
import { format } from "date-fns";
import screenfull from "screenfull";
import { menuList} from "@/api/tvlive";
import Bus from "@/eventBus/index.js";
import comment from "@/components/cloudComment/index.vue"
import {
  getLocalStorage
} from "@/utils/local-storage.js";
import {
  getUserInfo,
  getLoginStatus,
  opneLoginPane,
  liveHasLogin
} from "@/utils/app.js";
import { Toast } from 'vant';
export default {
  data() {
    return {
      playerType:'',
      valIndex:null,
      anyangIcon: require('../assets/img/logo.png'),
      originType:'',
      versionUrl: "",
      appName: "",
      appIcon: '',
      editableTabs:[],
      wxuserInfo: {},//登录数据
      activeName:0,
      controlsFlag: false,
      tempPlayurl: "",
      tvInfo: {},
      getListData: {
        pageIndex: 1,
        pageSize: 999,
        createTime: "",
        tvId: this.$route.query.id,
      },
      finished: false,
      loading: false,
      programList: [],
      dayList: [],
      noplay: false,
      iosControlsShow: false,
      iosfull: false,
      clicked: true,
      endimg: false,
      begin: true,
      endtime: 9000,
      activityAuthor: "",
      countDownSwitch: 0,
      time: 5000,
      userinfo: {},
      controlsShow: false,
      videoControls: {
        play: false,
        openTD: false,
        fullScreen: false,
      },
      iosVideoControls: {
        play: false,
        openTD: false,
        fullScreen: false,
      },
      controlsTimer: "",
      active: 0,
      playUrl: "2333",
      page: {},
      count1: 0,
      info: {
        origin: 'web',
        nickname:'游客',
        id:'游客'+Math.round(Math.random()*1000),
        headimgurl: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      },
      tvType:'',
      option: {
        isLive: true, //切换为直播流的时候必填
        width: "100%",
        height: "100%",
        useH5Prism: true,
        diagnosisButtonVisible: false,
        autoplay: false,
        preload: true,
        mediaType: "video",
        language: "zh-custom", // 自定义语言包
        languageTexts: {
          // 播放器自定义提示文字
          "zh-custom": {
            Video_Error: "这是测试文字...", // 视频播放异常
            Error_Load_M3U8_Timeout_Text: "获取m3u8文件超时", // 获取m3u8文件超时
            Error_Load_M3U8_Failed_Text: "获取m3u8文件失败", //  获取m3u8文件失败
            Live_Abrot: "这是测试文字...", // 直播信号中断
            Error_Not_Found: "这是测试文字...", // 播放地址不存在
            Refresh_Text: "刷新",
            Retry: "重试",
            Detection_Text: "诊断CA",
          },
        },
      },
    };
  },
  filters:{
        ellipsis(value){
          if (!value) return '';
          if (value.length > 10) {
            return value.slice(0,10) + '...'
          }
          return value
        }
      },
  computed: {
    ...mapState(["inWX", "IOS", "Android"]),
    playsinline() { // app判断
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false;
      } else {
        //ios端
        return true;
      }
    },
  },
  created() {
    //获取页面详情
    window.sessionStorage.setItem("id", this.$route.query.id);
    window.sessionStorage.setItem("tvType", this.$route.query.tvType);
    this.tvType = this.$route.query.tvType
    //登录app后更新用户信息
    Bus.$on("update:userInfo", (data) => {
      let userinfo = data
      if (userinfo) {
        this.wxuserInfo = {
          nickname: JSON.parse(userinfo).data.userNick,
          headimgurl: JSON.parse(userinfo).data.userHeadPath,
          id: JSON.parse(userinfo).data.userId,
          origin: 'app'
        }
      }
      console.log('获取用户信息',data);
      // window.location.reload();
    });
    if (this.inWX) {
      let userinfo = sessionStorage.getItem("userinfo");
      if (userinfo) {
        this.wxuserInfo = JSON.parse(userinfo);
        this.wxuserInfo = {
          nickname: JSON.parse(userinfo).nickname,
          headimgurl: JSON.parse(userinfo).headimgurl,
          id: JSON.parse(userinfo).openid,
          origin: 'wechat'
        }
      } else {
        // this.$router.replace({ name: "login", query: { id: this.$route.query.id,tvType: this.$route.query.tvType } });
      }
    } else {
      liveHasLogin({
        success: () => {
          Toast('已登录')
          let userinfo = sessionStorage.getItem("userinfo");
          if (userinfo) {
            this.wxuserInfo = {
              nickname: JSON.parse(JSON.parse(userinfo)).data.userNick,
              headimgurl: JSON.parse(JSON.parse(userinfo)).data.userHeadPath||'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
              id: JSON.parse(JSON.parse(userinfo)).data.userId,
              origin: 'app'
            }
          }
        },
        failed: () => {
          Toast('未登录')
          // opneLoginPane();
        },
      });
      if (this.IOS) {
        // getLoginStatus();
        let userinfo = sessionStorage.getItem("userinfo");
        if (userinfo) {
          this.wxuserInfo = {
            nickname: JSON.parse(JSON.parse(userinfo)).data.userNick,
            headimgurl: JSON.parse(JSON.parse(userinfo)).data.userHeadPath||'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            id: JSON.parse(JSON.parse(userinfo)).data.userId,
            origin: 'app'
          }
        }
      } else if (this.Android) {
        // getLoginStatus();
        let userinfo = sessionStorage.getItem("userinfo");
        if (userinfo) {
          this.wxuserInfo = {
            nickname: JSON.parse(JSON.parse(userinfo)).data.userNick,
            headimgurl: JSON.parse(JSON.parse(userinfo)).data.userHeadPath||'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            id: JSON.parse(JSON.parse(userinfo)).data.userId,
            origin: 'app'
          }
        }
      } else {
        this.wxuserInfo = {
          // origin:'web',
          // nickname:'主持人',
          // id:'主持人',
          // headimgurl:"https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
        };
      }
    }
    if (this.$route.query.id&&this.$route.query.tvType) {
      if (this.$route.query.tvType=='4') { // 路况
        this.getRoadDetail(this.$route.query.id)
      }else{
        this.getDetail(this.$route.query.id)
      }
      
    }
  },
  mounted () {
    if (this.equipmentType() == "iOS") {
      this.originType = 0;
    } else if (this.equipmentType() == "Android") {
      this.originType = 1;
    } else {
      this.originType = 3;
    }
    sctipts
        .getAppUrl({
          type: this.originType,
          bundleID: this.$route.query.bundleID
        })
        .then(({
          data
        }) => {
          if (data.status == 0) {
            if (data.data) {
              this.versionUrl = data.data.versionUrl;
              this.appName = data.data.applicationName;
              this.appIcon = data.data.applicationHeadPath;
              this.appScheme = data.data.applicationUrlScheme
            }
          } else {
            console.log(data.desc);
          }
    });
    const timeobj = {
      time: format(new Date(), "yyyMMdd"),
    };
    this.tabclick(timeobj);
    this.getMenuList(this.$route.query.id,this.$route.query.tvType)
    // this.getRecentDays()
  },
  components: {
    comment,
    VueAliplayerV2:()=>import("@/components/playerbox/livePlayer"),
  },
  methods: {
    handleClickForHome(){
      var oA = document.createElement("a"); //创建a标签
      oA.href = "https://www.kftv.net.cn";
      oA.target = "_self"; //添加 target 属性
      oA.click(); //模拟点击
    },
    equipmentType () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    downApp (item) {
      // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(1)}?sourceId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(1)}?sourceId=${this.$route.query.id}`;
        }
      var downUrl = location.origin+'/invitation?type='+this.$route.query.type+'&bundleID='+this.$route.query.bundleID;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          var loadDateTime = new Date();
          window.setTimeout(function() {
              var timeOutDateTime = new Date();
              if (timeOutDateTime - loadDateTime < 5000) {
                //下载分享页
                window.location = downUrl;
              } else {
                window.close();
              }
          },500);
          window.location = link;
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          window.location.href = link;
          window.setTimeout(() => {
            //下载分享页
            window.location = downUrl
          }, 2500);
        }
      }
    },
    getDetail () { // 获取电视等详情
      axios
        .get(`/tv/preview/${this.$route.query.id}`)
        .then((res) => {
          if (res.data.status == 0) {
            this.tvInfo = res.data.data.list[0];
            document.title = this.tvInfo.tvName;
            // this.playUrl = this.tvInfo.hlsPlayPath;
            // this.tempPlayurl = this.tvInfo.hlsPlayPath;


            if (this.tvInfo.passagewayType == 1) {
              // 推流
              this.playUrl = this.tvInfo.hlsPlayPath;
              this.tempPlayurl = this.tvInfo.rtmpPushPath;
            } else if (this.tvInfo.passagewayType == 0) {
              // // 拉流
              // this.playUrl = this.tvInfo.pullPath;
              // this.tempPlayurl = this.tvInfo.rtmpPushPath;
              // 拉流 转推 retweetedFlag = 1 取 hlsPlayPath, 不转推 retweetedFlag = 0 取   pullPath
              if (this.tvInfo.retweetedFlag==1) {
                this.playUrl = this.tvInfo.hlsPlayPath;
                this.tempPlayurl = this.tvInfo.rtmpPushPath;
              } else{
                this.playUrl = this.tvInfo.pullPath;
                this.tempPlayurl = this.tvInfo.rtmpPushPath;
              }
            }
            var index = this.playUrl.lastIndexOf(".");
            var ext = this.playUrl.substr(index + 1);
            var ipos = ext.indexOf("?")||ext;//指定开始的字符串
            let str1 =ipos==-1?ext:ext.substring(0,ipos); //取前部分（指定开始的字符串的之前
            if(str1 == 'm3u8') {
              this.playerType = 'application/x-mpegURL'
            }else if(ext == 'flv') {
              this.playerType = 'video/x-flv'
            }else if(ext == 'mov') {
              this.playerType = 'rtmp/mp4'
            }else if(ext == 'mp4'){
              this.playerType = 'video/mp4'
            }
          }
          
        });
    },
    getRoadDetail () { // 获取路况详情
      axios
        .get(`/traffic/preview/${this.$route.query.id}`)
        .then((res) => {
          if (res.data.status == 0) {
            this.tvInfo = res.data.data.list;
            document.title = this.tvInfo.trafficTitle;
            if (this.tvInfo.passagewayType == 1) {
              // 推流
              this.playUrl = this.tvInfo.hlsPlayPath;
              this.tempPlayurl = this.tvInfo.rtmpPushPath;
            } else if (this.tvInfo.passagewayType == 0) {
              // 拉流 转推 retweetedFlag = 1 取 hlsPlayPath, 不转推 retweetedFlag = 0 取   pullPath
              if (this.tvInfo.retweetedFlag==1) {
                this.playUrl = this.tvInfo.hlsPlayPath;
                this.tempPlayurl = this.tvInfo.rtmpPushPath;
              } else{
                this.playUrl = this.tvInfo.pullPath;
                this.tempPlayurl = this.tvInfo.rtmpPushPath;
              }
            }
            var index = this.playUrl.lastIndexOf(".");
            var ext = this.playUrl.substr(index + 1);
            var ipos = ext.indexOf("?")||ext;//指定开始的字符串
            let str1 =ipos==-1?ext:ext.substring(0,ipos); //取前部分（指定开始的字符串的之前
            if(str1 == 'm3u8') {
              this.playerType = 'application/x-mpegURL'
            }else if(ext == 'flv') {
              this.playerType = 'video/x-flv'
            }else if(ext == 'mov') {
              this.playerType = 'rtmp/mp4'
            }else if(ext == 'mp4'){
              this.playerType = 'video/mp4'
            }
          }
          
        });
    },
    tabsClick (name) {
      var names=parseInt(name)
      if (names == 6) {
          this.$nextTick(() => {
            if (this.$refs.childMethod[0]) {
              this.$refs.childMethod[0].socketOpen('chat', this.$route.query.id, this.wxuserInfo)
            }
          })
      }
      if (names == 7) {
        this.$nextTick(() => {
          this.getRecentDays()
        })
      }
    },
    // 获取tabs栏目
    getMenuList(tvId,type) {
      menuList(tvId,1).then((res) => {
        if (res.data.data.length>0) {
          this.editableTabs = res.data.data;
          this.activeName=this.editableTabs[0].menuType.toString()
          setTimeout(() => {
            this.tabsClick(this.activeName);
          }, 500);
        }else{
          this.editableTabs=[]
        }
      });
    },
    format,
    showLive(val,ind) {
      this.valIndex = ind
      this.programList.forEach((item) => {
        this.$set(item, "clicked", false);
      });
      this.controlsFlag = false;
      this.playUrl = this.tempPlayurl;
      this.videoPlay();
    },
    playing(playtime, length) {
      return Date.now() > playtime && Date.now() < playtime + length * 1000;
    },
    replay(val,ind) {
      this.valIndex = ind
      if (!val.playPath) return this.$toast.fail("此时间段暂无录制视频");
      this.programList.forEach((item) => {
        this.$set(item, "clicked", false);
      });
      this.$set(val, "clicked", true);

      this.controlsFlag = true;
      this.videoPlay();
      this.playUrl =
        val.playPath || "//player.alicdn.com/video/aliyunmedia.mp4";
    },
    getList() {
      if (this.$route.query.id) {
        axios
          .get(`/program`, { params: this.getListData })
          .then(({ data }) => {
            if (data.status == 0) {
              this.programList = data.data.list;
              this.loading = false;
              if (this.programList.length == data.data.total) {
                this.finished = true;
              }
            }
          })
          .catch((res) => {
            // console.log(res);
          });
      }
    },
    onLoad() {
      this.getListData.pageSize += 10;
      this.getList();
    },
    getRecentDays() {
      var weekDay = [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      //获取当前日期的前后几天
      for (let i = 1; i < 12; i++) {
        let obj = {};
        obj.time = this.getNextDate(new Date(), i - 6);
        let myDate = new Date(Date.parse(obj.time.replace(/-/g, "/")));
        obj.day = weekDay[myDate.getDay()];
        this.dayList.push(obj);
      }

      //默认选中当前日期
      this.dayList.filter((item, index) => {
        if (item.time == format(new Date(), "yyyy/MM/dd")) {
          this.active = index;
          return true;
        } else {
          return false;
        }
      });
    },
    getNextDate(date, day) {
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "/" + m + "/" + d;
    },
    onreplay() {
      this.videoPlay();
    },
    tabclick(val) {
      this.getListData.createTime = val.time.split("/").join("") || val;
      this.getList();
      this.getListData.pageSize = 999;
    },
    onfinish() {
      this.countDownSwitch = 0;
      this.begin = true;
    },
    time1(val) {
      return val < 10 ? "0" + val : val;
    },
    playVideo() {
      this.videoPlay();
    },
    //显示控制条
    controlsShowFun() {
      this.controlsShow = true;
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.controlsTimer = setTimeout(() => {
        this.controlsShow = false;
      }, 1000);
    },
    iosControlsShowFun() {
      this.iosControlsShow = true;
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.controlsTimer = setTimeout(() => {
        this.iosControlsShow = false;
      }, 2000);
    },
    //隐藏控制条
    controlsHiddenFun() {
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.controlsShow = false;
    },

    iosControlsHiddenFun() {
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.iosControlsShow = false;
    },
    //全屏方法
    videoFullScreen() {
      if (this.IOS) {
        this.iosfull = true;
        this.videoPause();
        this.iosVideoPlay();
      } else {
        this.videoPlay();
        let ele = this.$refs["video"];
        if (ele.requestFullscreen) {
          ele.requestFullscreen();
        } else if (ele.mozRequestFullScreen) {
          ele.mozRequestFullScreen();
        } else if (ele.webkitRequestFullScreen) {
          ele.webkitRequestFullScreen();
        }
        this.videoControls.play = true;
      }
    },

    iosVideoFullScreen() {
      this.iosfull = false;
      this.videoPlay();
    },
    //播放
    videoPlay() {
      // this.replay();
      this.clicked = false;
      this.controlsShowFun();
      this.videoControls.play = true;
      this.$refs["video"].play();
    },
    iosVideoPlay() {
      this.iosControlsShowFun();
      this.iosVideoControls.play = true;
      this.$nextTick(() => {
        this.$refs["iosvideo"].play();
      });
    },
    //暂停播放
    videoPause() {
      this.controlsShowFun();
      this.videoControls.play = false;
      this.$refs["video"].pause();
    },
    iosVideoPause() {
      this.iosControlsShowFun();
      this.iosVideoControls.play = false;
      this.$refs["iosvideo"].pause();
    },
    //打开通道菜单
    openTDWind() {
      this.controlsHiddenFun();
      this.videoControls.openTD = true;
    },
    //关闭通道菜单
    closeTDWind() {
      this.videoControls.openTD = false;
      this.controlsShowFun();
    },
  },
  //登出
  beforeDestroy() {
    if (this.tim) {
      this.tim.logout();
    }
  },
};
</script>
<style>

.van-tab.van-tab--active {
  color: #be1928;
  border-bottom: 0 !important;
}
.page-box .van-tab{
  font-size: 12px;
}
.page-box .van-tabs__line {
 width: 15px;
 background-color: #be1928 !important;
}
.van-tabs__wrap.van-tabs__wrap--scrollable {
  padding: 0 10px;
}
.tabs-box .van-tabs__line {
 display: none;
}
.program-list-box .van-button--info{
  background-color: #fff;
  border: 1px solid #ebedf0;
}
.program-list-box .van-button--info .van-button__content{
  width: 100%;
  height: 100%;
  background-image: url('../assets/img/liveIng.png');
  background-repeat: no-repeat;
  background-size: 20px 16px;
  background-position: center;
}
</style>
<style scoped>
.footer img{
  width: 100%;
  height: 100%;
  display: block;
}
.down-app-btn {
  width: 81px;
  height: 32px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #be1928;
  background-color: #be1928;
}
.app-view {
  width: 100%;
  max-width: 677PX;
  height: 50PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 13PX;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fafafa;
  border-bottom: 1PX solid #eee;
  z-index: 99999;
}

.app-view > li:nth-child(1) {
  height: 44PX;
}

.app-view > li:nth-child(1) > img {
  height: 44PX;
  display: block;
  float: left;
}

.app-view > li:nth-child(1) > p {
  font-size: 14PX;
  color: #333333;
  float: left;
  margin-left: 8PX;
  line-height: 44PX;
}

.app-view > li:nth-child(2) {
  height: 44PX;
  overflow: hidden;
}
.margintop{
  margin-top:12px;
}
.app-view > li:nth-child(2) > a {
  display: block;
  width: 81PX;
  height: 26PX;
  background-color: #518dfa;
  border: none;
  color: #fff;
  font-size: 14PX;
  outline: none;
  text-align: center;
  line-height: 26PX;
  text-decoration: none;
  border-radius: 5PX;
}
.list-gift-list-item {
  height: 45px;
  border-top: 1px solid #f3f3f3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  font-size: 14px;
}
.program-list-box {
  height: 350px;
  margin-top: 10px;
  overflow-y: auto;
}
.active {
  color: #4594ff;
}
.play-time {
  margin-right: 10px;
}
.play-name {
  font-weight: bold;
  color: #333;
  font-family: SourceHan;
}
.program-list {
  height: 85px;
  overflow: auto;
}
.program-list .program-item:nth-child(1) {
  margin-top: 12px;
  border-top: 1px solid #e9e9e9;
}
.program-list-box .van-button {
  width: 60px;
  height: 26px;
  padding: 0;
  margin-top: 6px;
  line-height: 24px;
  
}
/* .program-item div:nth-child(1) span{
  margin-right: 10px;
} */
.channel-list {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.channel-list div:nth-child(1) {
  font-size: 16px;
  margin: 18px;
  line-height: 22px;
}
.channel-list div:nth-child(2) {
  font-size: 16px;
  margin: 18px;
}
.channel-list div:nth-child(2) .van-icon {
  vertical-align: middle;
  font-weight: 600;
  font-size: 18px;
}
.channel-list div:nth-child(2) span {
  margin: 0 10px;
}
.icon-xiaoping {
  font-size: 30px;
}
.noplay {
  top: 0;
  position: absolute;
  background-image: url("../assets/img/noplay.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
  z-index: 9;
}
.iosvideo {
  width: 100%;
  height: 100vh;
  background-color: #000;
  z-index: 9999999;
  object-fit: contain;
  position: fixed;
  top: 0;
  left: 0;
}
.ios-box {
  width: 100%;
  position: relative;
  top: 0px;
  overflow: hidden;
  /* transform: rotate(50deg); */
}
.playbtn {
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-image: url("../assets/img/playbg.png");
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.playbtn .begin-play {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.endimg {
  top: 0;
  position: absolute;
  background-image: url("../assets/img/jieshu.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
}
.shouqi {
  width: 16px;
  position: absolute;
  bottom: 10px;
  left: calc(50% - 8px);
}
.qwe {
  opacity: 0;
}
.zhanwei {
  position: absolute;
  background-image: url("../assets/img/jingcaiz.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
}
.fabu {
  position: absolute;
  color: #fff;
  z-index: 99;
  background-color: #303030;
  border-radius: 8px;
  font-size: 14px;
  top: 5%;
  left: 6%;
  padding: 2px 6px;
}
.daoji {
  height: 200px;
  margin-top: 90px;
}
.colon {
  display: inline-block;
  margin: 0 10px;
  color: #5ee2ff;
  font-size: 20px;
}
.block {
  display: inline-block;
  width: 22px;
  color: #5ee2ff;
  font-size: 24px;
  text-align: center;
}
.count {
  text-align: center;
  position: absolute;
  width: 80%;
  background-image: url("../assets/img/daoji.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
}
.count p {
  color: #5ee2ff;
  margin-bottom: 10px;
  font-size: 18px;
}
.page-box {
  overflow: hidden;
  height: 100%;
}
.video-box {
  width: 100%;
  height: 210px;
  overflow: hidden;
  position: relative;
}
.controls-box {
  z-index: 999;
  width: 100%;
  height: 210px;
  background-image: url("../assets/img/video_bg.png");
  background-repeat: repeat-x;
  background-position: center;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 0;
}
.controls-box-title {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
}
.zhankai {
  width: 16px;
  height: 16px;
}
.controls-box-title > li {
  height: 20px;
  margin-left: 15px;
  background-color: #000;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 5px;
}
.controls-box-controls {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0 15px;
  box-sizing: border-box;
}
.controls-box-controls > li {
  font-size: 26px;
  color: #fff;
}

.controls-box-ios {
  width: 100%;
  height: 470px;
  position: fixed;
  bottom: 1vh;
  z-index: 9999999999;
}
.controls-box-ios .controls-box-controls {
  width: 370px;
}

.TD-box {
  z-index: 99999;
  width: 100%;
  height: 210px;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("../assets/img/video_bg.png");
  background-repeat: repeat-x;
  background-position: center;
  background-size: contain;
}
.TD-list {
  width: 100%;
  overflow-x: auto;
  height: 100px;
  position: absolute;
  top: 80px;
  left: 0;
  display: flex;
}
.TD-list > li {
  flex-shrink: 0;
  width: 102px;
  height: 90px;
  margin-left: 7px;
}
.TD-list > li:first-child {
  margin-left: 15px;
}
.TD-list > li:last-child {
  margin-right: 15px;
}
.TD-list > li > div {
  display: block;
  border-radius: 4px;
  overflow: hidden;
  background-color: #000;
  border: 1px solid transparent;
}
.TD-list > li > p {
  color: #fff;
  font-size: 14px;
  height: 14px;
  line-height: 14px;
  margin-top: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.TD-list > .TD-focus > div {
  border: 1px solid #5f93ff;
}
.TD-list > .TD-focus > p {
  color: #5f93ff;
}
.back-bottom-btn {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 8px;
  color: #fff;
  font-size: 30px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: left;
}
.video {
  width: 100%;
  height: 210px;
  display: block;
  background-color: #000;
}
.tabs-box {
  width: 100%;
  height: calc(100vh - 254px);
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 55px;
  box-sizing: border-box;
  padding-top: 20px;
}
.tv-info {
  width: calc(100% - 30px);
  margin: 0 auto;
  overflow: hidden;
}
</style>
<style>
.tv-info img {
  max-width: 100% !important;
  object-fit: contain;
  height: auto !important;
}
.tv-introduce{
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
}
.tv-introduce img{
  width: 100%;
  opacity: 1;
  border-radius: 0px;
  }
.road-info{
  height: 85px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
}
.road-info .left-img{
  width: 107px;
  height: 62px;
  margin-right: 12px;
}
.road-info .right-box{
  width:267px;
}
.road-info .right-box .title{
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 44px;
}
.road-info .right-box .address{
  font-size: 12px;
  font-weight: 400;
  color: #999;
  margin-top: 5px;
}
.road-info .right-box.address i{
  font-size: 20px;
}
.road-box{
  height: calc(100vh - 254px - 170px);
}
.clicked-item .play-time,.clicked-item .play-name{
  color: #be1928;
}
</style>
